<template>
  <input-select
    id="lgbtq"
    :value="value"
    name="lgbtq"
    label="LGBTQ+ Status"
    placeholder="Any"
    placeholder-enabled
    :options="[
      { id: 'true', display_label: 'LGBTQ+' }
    ]"
    @input="val => $emit('input', val)"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'LgbtqPicker',

  components: {
    InputSelect
  },

  props: {
    value: {
      type: String,
      required: true
    }
  },
};
</script>
